// Define an enum with string literal values
enum MeasurementUnitsEnum {
  Milliliters = 'milliliters',
  Liters = 'liters',
  FluidOunces = 'fluid_ounces',
  Grams = 'grams',
  Kilograms = 'kilograms',
  Gallons = 'gallons',
  Ounces = 'ounces',
  Pounds = 'pounds',
  Centimeters = 'centimeters',
  Feet = 'feet',
  Inches = 'inches',
  Whole = 'whole',
}

// Create a constant array to define the MeasurementUnits Type

const MeasurementUnits: { value: string; label: string }[] = [
  { value: MeasurementUnitsEnum.Centimeters, label: 'سنتيمتر' },
  { value: MeasurementUnitsEnum.Feet, label: 'قدم' },
  { value: MeasurementUnitsEnum.Gallons, label: 'جالون' },
  { value: MeasurementUnitsEnum.Grams, label: 'جرام' },
  { value: MeasurementUnitsEnum.Inches, label: 'بوصة' },
  { value: MeasurementUnitsEnum.Kilograms, label: 'كيلوجرام' },
  { value: MeasurementUnitsEnum.Liters, label: 'لتر' },
  { value: MeasurementUnitsEnum.Milliliters, label: 'مليليتر' },
  { value: MeasurementUnitsEnum.Ounces, label: 'أونصة' },
  { value: MeasurementUnitsEnum.Pounds, label: 'رطل' },
  { value: MeasurementUnitsEnum.Whole, label: 'كلي' },
];

export { MeasurementUnitsEnum, MeasurementUnits };
